import { Dispatch } from 'redux'
import cookie from 'react-cookies'
import { AuthStoreService } from './service'
import { FETCH_AUTH_REQUEST, FETCH_AUTH_SUCCESS, FETCH_AUTH_FAILURE } from './types'

const requested = () => {
  return {
    type: FETCH_AUTH_REQUEST,
  }
}

const loaded = (newData: any) => {
  return {
    type: FETCH_AUTH_SUCCESS,
    payload: newData,
  }
}

const error = (errorData: any) => {
  return {
    type: FETCH_AUTH_FAILURE,
    payload: errorData,
  }
}

export const AuthAction =
  ({ onSuccess = (data?: any) => {}, onError = () => {} }) =>
  (dispatch: Dispatch) => {
    dispatch(requested())

    AuthStoreService()
      .then((data) => {
        dispatch(loaded(data.data))
        onSuccess(data.data)
        if (data && data.user) {
          cookie.save('_UID', data.user.id, { path: '/' })
        }
      })
      .catch(({ status, data }) => {
        cookie.save('_UID', '', { path: '/' })
        if (status === 402) {
          dispatch(loaded(data.data))
          onSuccess(data.data)
        } else {
          dispatch(error(data))
          onError()
        }
      })
  }
